'use client';

import { usePathname } from 'next/navigation';
import Header from './Header';

export default function ConditionalHeader() {
  const pathname = usePathname();
  
  // Hide header on story detail pages and chapter pages
  const hideHeader = pathname?.startsWith('/story/')||pathname?.startsWith('/login')||pathname?.startsWith('/admin');
  
  if (hideHeader) {
    return null;
  }
  
  return <Header />;
}
